export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/damir-bosnjak-a6f24e7dd5470a8bd2f48ebb53dbe8d5.jpg";